export enum Property {
    AccountType = 1,
    Position = 2,
    Organization = 3
}
